import { CollapsibleContainer } from 'components/common'
import React, { useEffect, useRef, useState } from 'react'
import OptionsSection from './OptionsSection'
import { ModalCreateSection, UserCard } from 'components/Sidemenu/SideMenuInChat/components'
import './styles.scss'
import ModalDelete from 'components/ModalDelete'
import { lang } from 'utils/helpers'
import { apiInchat } from 'api'
import { useDispatch } from 'react-redux'
import inchatActions from 'redux/inchat/actions'
import { Draggable, Droppable } from 'react-beautiful-dnd'

const SectionsCollapsible = (props) => {

  const { conversation, openCard } = props
  const [isOpenCollapsible, setIsOpenCollapsible] = useState(true)
  const [isHide, setIsHide] = useState(true)
  const [modalDeleteOpen, setModalDeleteOpen] = useState(false)
  const [modalEditSectionOpen, setModalEditSectionOpen] = useState(false)
  const [submitDelete, setSubmitDelete] = useState(false)
  const [messageErrorDelete, setMessageErrorDelete] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const first = useRef(true)
  const dispatch = useDispatch()

  useEffect(() => {
    if (first.current) {
      first.current = false
      return
    }
    if(isOpenCollapsible){
      getConversationSection()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenCollapsible])

  const getConversationSection = async () => {
    setIsLoading(true)
    await dispatch(inchatActions.getDirectConversationsList(false, conversation._id))
    setIsLoading(false)
  }

  const handleOpenToggle = () => {
    setIsOpenCollapsible(state => !state)
  }

  const handleOpenCard = (conversation) => {
    openCard(conversation._id)
  }

  const handleDeleteSection = () => {
    setSubmitDelete(true)
    setMessageErrorDelete('')
    apiInchat.deleteSection(conversation._id)
      .then(({ data }) => {
        if(!data) {
          setMessageErrorDelete('dashboard_error_delete_section')
          return
        }
        toggleModalDelete()
        setTimeout(() => {
          dispatch(inchatActions.removeSection(conversation._id))
        }, 300)
      })
      .catch(() => setMessageErrorDelete('dashboard_error_delete_section'))
      .finally(() => setSubmitDelete(false))

  }

  const toggleModalDelete = () => {
    setModalDeleteOpen(state => !state)
    setMessageErrorDelete('')
  }

  const toggleModalEdit = () => {
    setModalEditSectionOpen(state => !state)
  }

  return (
    <Droppable
      droppableId={conversation._id}
      type={'CONVERSATIONS'}
      direction='vertical'
    >
      {(provider_sections, snapshot) => (
        <div
          className={`
            inchat-sections-container
            ${snapshot.isDraggingOver ? 'inchat-sections-container__dragging' : ''}
          `}
          ref={provider_sections.innerRef}
          {...provider_sections.droppableProps}
        >
          <CollapsibleContainer
            isOpen={isOpenCollapsible}
            theme={'dark'}
            toggle={handleOpenToggle}
            height={250}
            isLoading={isLoading}
            title={conversation.name}
            onChangeMouseOver={(value) => setIsHide(!value)}
            optionsComponent={
              <div className='inchat-menu__options-collapsible'>
                <OptionsSection
                  isHide={isHide}
                  toggleModalDelete={toggleModalDelete}
                  toggleModalEdit={toggleModalEdit}
                />
              </div>
            }
            id={conversation._id}
            className='inchat-sections-container__collapsible'
          >
            <div
              className='inchat-sections-container__list'
            >
              {conversation.conversations.map((conversation, index) => {
                return (
                  <Draggable
                    key={conversation._id}
                    draggableId={conversation._id}
                    index={index}
                    isDragDisabled={!conversation._id ? true : false}
                  >
                    {(provider_card)=>(
                      <div
                        ref={provider_card.innerRef}
                        style={{
                          ...provider_card.draggableProps.style
                        }}
                        {...provider_card.draggableProps}
                        {...provider_card.dragHandleProps}
                      >
                        <UserCard
                          key={conversation._id}
                          conversation={conversation}
                          onClick={handleOpenCard}
                        />
                      </div>
                    )}
                  </Draggable>
                )
              })}
              {provider_sections.placeholder}
            </div>
          </CollapsibleContainer>
          { modalDeleteOpen &&
            <ModalDelete
              isOpen={modalDeleteOpen}
              toggle={() => {
                toggleModalDelete()
              }}
              header={lang('dashboard_delete_section')}
              text1={lang('dashboard_delete_section_question')}
              text2={lang('dashboard_delete_section_legend')}
              event={handleDeleteSection}
              isSubmitting={submitDelete}
              errorMessage={messageErrorDelete}
            />
          }
          {modalEditSectionOpen&&
            <ModalCreateSection
              isOpenModal={modalEditSectionOpen}
              toggleModal={toggleModalEdit}
              dispatch={dispatch}
              conversation={conversation}
            />
          }
        </div>
      )}
    </Droppable>
  )
}

export default SectionsCollapsible